export default __webpack_public_path__ + "static/media/english-to-italian-mobile-3.960e3b34.png";